import { render, staticRenderFns } from "./FormTableDetail.vue?vue&type=template&id=439e217f&scoped=true"
import script from "./FormTableDetail.vue?vue&type=script&lang=js"
export * from "./FormTableDetail.vue?vue&type=script&lang=js"
import style0 from "./FormTableDetail.vue?vue&type=style&index=0&id=439e217f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439e217f",
  null
  
)

export default component.exports